export default __webpack_public_path__ + "static/media/mainlogo.ab7ce6a9.png";